/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { useIntl } from 'react-intl';
import { dropzoneStyle } from '../styles';

const fileUploadSvg = "data:image/svg+xml," + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="%23277EA1" d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"/></svg>'
);

export function StyledDropzone({ validator, onDropAccepted, onDropRejected, maxFileSize, accept }) {
  const { formatMessage } = useIntl();

  const { getRootProps, getInputProps } = useDropzone({
    validator,
    onDropAccepted,
    onDropRejected,
    maxSize: maxFileSize,
    multiple: false,
    accept
  });

  const style = useMemo(() => ({ ...dropzoneStyle }), []);

  return (
    <div {...getRootProps({ style })}>
      <input {...getInputProps()} />
      <img src={fileUploadSvg} alt="fileUpload" width="48px" className="filter-blue" />
      <p style={{ fontSize: '18px', color: '#3E3E3E', marginTop: '18px' }}>
        {formatMessage({ id: 'form.dragFiles' })}
        <span style={{ color: '#277EA1' }}> {formatMessage({ id: 'form.browseFiles' })}</span>
      </p>
    </div>
  );
}
